module.exports = __webpack_public_path__ + "img/edit_link.ab4cb9a1.svg";